/**
 * User-facing terminology for the core entity and the uploaded spreadsheet.
 * The entity was renamed "Project" → "File" (and the uploaded spreadsheet
 * "file" → "data source") and may be renamed again — see the "Terminology"
 * section in replit.md for the full list of touchpoints.
 */
export const TERMINOLOGY = {
  /** Singular entity name, capitalized ("File"). */
  entity: 'File',
  /** Plural entity name, capitalized ("Files"). */
  entityPlural: 'Files',
  /** Singular entity name, lowercase, for mid-sentence use ("file"). */
  entityLower: 'file',
  /** Plural entity name, lowercase, for mid-sentence use ("files"). */
  entityPluralLower: 'files',
  /** Uploaded-spreadsheet term, capitalized ("Data Source"). */
  dataSource: 'Data Source',
  /** Uploaded-spreadsheet term, lowercase, for mid-sentence use ("data source"). */
  dataSourceLower: 'data source',
} as const;

export class GlobalConstants {
  public static appInfo = {
    appName: 'Client Cross Reference',
    appVersion: '1.0.0',
  };
  public static mainNav: { label: string; path: string }[] = [];
  public static userNav: { label: string; path: string }[] = [
    {
      label: 'Redis Cache Stats',
      path: '/redis-stats',
    },
  ];
}
